export default {
  home: 'Dashboards',
  servers: 'Серверы',
  settings: 'Настройки',
  user_settings: 'Пользователь',
  ui_settings: 'Настройки интерфейса',
  system_settings: 'Система',
  lists: 'Списки',
  reports: 'Отчеты'
}
